var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._b({staticClass:"v-chip--label-custom",attrs:{"label":""},on:{"click":_vm.handleClick}},'v-chip',_vm.chipProps,false),[_vm._v(_vm._s(_vm.value))])}
var staticRenderFns = []

export { render, staticRenderFns }